import _regeneratorRuntime from "@babel/runtime/regenerator";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import { Head } from '@inertiajs/inertia-vue3';
import Icon from '@/Shared/Icon';
import pickBy from 'lodash/pickBy';
import Layout from '@/Shared/Layout';
import throttle from 'lodash/throttle';
import mapValues from 'lodash/mapValues';
import Pagination from '@/Shared/Pagination';
import SearchFilter from '@/Shared/SearchFilter';
import { Link } from '@inertiajs/inertia-vue3';
export default {
  components: {
    Head: Head,
    Icon: Icon,
    Pagination: Pagination,
    SearchFilter: SearchFilter,
    Link: Link
  },
  layout: Layout,
  props: {},
  data: function data() {
    return {
      form: {
        start_date: null,
        end_date: null,
        user_id: null
      },
      date: [],
      showAccountStat: false,
      userStat: [],
      selectedUser: "",
      tabsData: [],
      accountLevelStat: [],
      showTenantStat: false
    };
  },
  mounted: function mounted() {
    this.reset();
  },
  methods: {
    reset: function reset() {
      var end = new Date();
      end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
      var endDate = this.$helpers.changeDateFormat(end);
      var start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 8);
      var startDate = this.$helpers.changeDateFormat(start);
      this.form.start_date = startDate;
      this.form.end_date = endDate;
      this.form.user_id = null;
      this.date = [startDate, endDate];
      this.tabsData = [];
      this.showUserStatData();
    },
    dateChange: function dateChange(val) {
      this.tabsData = [];
      if (val) {
        this.form.start_date = val[0];
        this.form.end_date = val[1];
        this.form.user_id = null;
        this.showUserStatData();
      } else {
        this.form.start_date = null;
        this.form.end_date = null;
        this.form.user_id = null;
        this.showUserStatData();
      }
    },
    dateDisabled: function dateDisabled(time) {
      var max = new Date();
      max.setTime(max.getTime() - 3600 * 1000 * 24 * 1);
      return time.getTime() > max;
    },
    showUserStatData: function showUserStatData() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$store.loading = true;
                _context.next = 3;
                return axios.post('/data/get_user_stat', _this.form);
              case 3:
                res = _context.sent;
                _this.userStat = res.data.user_stat_data;
                _this.$store.loading = false;
              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    showAccountStatData: function showAccountStatData(row, column, index) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(column.label == "Account Level")) {
                  _context2.next = 3;
                  break;
                }
                _this2.getAccountLevelStat(row);
                return _context2.abrupt("return", true);
              case 3:
                _this2.$store.loading = true;
                _this2.form.user_id = row.user_id;
                _this2.tabsData.push(row);
                _context2.next = 8;
                return axios.post('/data/get_user_stat', _this2.form);
              case 8:
                res = _context2.sent;
                _this2.userStat = res.data.user_stat_data;
                _this2.$store.loading = false;
              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    goBack: function goBack(tab, tab_key) {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.tabsData.splice(tab_key);
                _context3.next = 3;
                return _this3.showAccountStatData(tab, [], "");
              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    getAccountLevelStat: function getAccountLevelStat(row) {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var data, res;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.$store.loading = true;
                _this4.selectedUser = row.user_name;
                data = {
                  user_id: row.user_id,
                  start_date: _this4.form.start_date,
                  end_date: _this4.form.end_date
                };
                _context4.next = 5;
                return axios.post('/data/get_account_stat', data);
              case 5:
                res = _context4.sent;
                _this4.accountLevelStat = res.data.account_stat_data;
                _this4.showTenantStat = true;
                _this4.$store.loading = false;
              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    }
  },
  computed: {
    shortcuts: function shortcuts() {
      var _this5 = this;
      return [{
        text: 'Last week',
        value: function value() {
          var end = new Date();
          end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
          var start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 8);
          return [_this5.$helpers.changeDateFormat(start), _this5.$helpers.changeDateFormat(end)];
        }
      }, {
        text: 'Last month',
        value: function value() {
          var end = new Date();
          end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
          var start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 31);
          return [_this5.$helpers.changeDateFormat(start), _this5.$helpers.changeDateFormat(end)];
        }
      }, {
        text: 'Last 3 months',
        value: function value() {
          var end = new Date();
          end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
          var start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 91);
          return [_this5.$helpers.changeDateFormat(start), _this5.$helpers.changeDateFormat(end)];
        }
      }];
    }
  }
};